import React, { useCallback } from 'react';
import {
  compose,
  withHandlers,
  withPropsOnChange,
  onlyUpdateForKeys,
} from 'recompose';
import { useHistory } from 'react-router-dom';
import { identity } from 'lodash';
import Icon from 'components/Icon';
import { useSelector } from 'react-redux';
import { getMerchantProp } from 'modules/user/selectors/merchant';
import cx from 'classnames';
import { createStructuredSelector } from 'reselect';

const logoImage = require('images/merch-cloud.png');
import styles from './styles.css';

const Logo = () => (
  <div className={styles.logoWrapper}>
    <img className={styles.logo} src={logoImage} alt="Merchant Cloud" />
  </div>
);
const Hamburger = <Icon name="home" width={27} height={27} />;

const mapStateToProp = createStructuredSelector({
  isTest: getMerchantProp('testStore'),
  storeName: getMerchantProp('merchantName'),
});

export default () => {
  const history = useHistory();
  const goHome = useCallback(() => history.push('/'), []);
  const { isTest, storeName } = useSelector(mapStateToProp);
  return (
    <button
      className={cx(styles.root, isTest && styles.testStore)}
      onClick={goHome}
    >
      <Logo />
      <div className={styles.storeName}>
        <div>{storeName}</div>
        {isTest && <div className={styles.testPrefix}>test environment</div>}
      </div>
    </button>
  );
};
